import { render, staticRenderFns } from "./MissingRegularCCsAfterOBKMigrationInsight.vue?vue&type=template&id=463f0ac7&scoped=true"
import script from "./MissingRegularCCsAfterOBKMigrationInsight.vue?vue&type=script&lang=js"
export * from "./MissingRegularCCsAfterOBKMigrationInsight.vue?vue&type=script&lang=js"
import style0 from "./MissingRegularCCsAfterOBKMigrationInsight.vue?vue&type=style&index=0&id=463f0ac7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463f0ac7",
  null
  
)

export default component.exports